import React from "react";
import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@material-ui/core";
import "../style.css";
import { isEmpty } from "lodash";
import { DATA_FETCH_STATUSES } from "..";

const SubscriptionInfoTable = ({ tableData, dataFetchingStatus }) => {
  return (
    <TableContainer className="subscription-stats-table">
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Subscription Plan</TableCell>
            <TableCell align="center">New Subscriptions</TableCell>
            <TableCell align="center">Renewed Subscriptions</TableCell>
            <TableCell align="center">Cancelled Subscriptions</TableCell>
          </TableRow>
        </TableHead>
        {dataFetchingStatus === DATA_FETCH_STATUSES.FETCHING ? (
          <TableBody>
            <TableRow>
              <TableCell align="center" colSpan={4}>
                <CircularProgress size={15} />
              </TableCell>
            </TableRow>
          </TableBody>
        ) : dataFetchingStatus === DATA_FETCH_STATUSES.FETCHED &&
          isEmpty(tableData.tableBody) ? (
          <TableBody>
            <TableRow>
              <TableCell align="center" colSpan={4}>
                No Results Found
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <>
            <TableBody>
              {tableData.tableBody.map((row) => (
                <TableRow>
                  <TableCell align="center">{row.pricingTierId}</TableCell>
                  <TableCell align="center">{row.totalNew}</TableCell>
                  <TableCell align="center">{row.totalRenew}</TableCell>
                  <TableCell align="center">{row.totalCancel}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell align="center">Total</TableCell>
                <TableCell align="center">
                  {tableData.tableSum?.totNew}
                </TableCell>
                <TableCell align="center">
                  {tableData.tableSum?.totRenew}
                </TableCell>
                <TableCell align="center">
                  {tableData.tableSum?.totCancel}
                </TableCell>
              </TableRow>
            </TableFooter>
          </>
        )}
      </Table>
    </TableContainer>
  );
};

export default SubscriptionInfoTable;
